
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinpanvel() {



const cardData =
{
  keyword: 'Corporate Cab Service in Panvel',
  heading: 'eTravo: Corporate Cab Service in Panvel for Business Mobility',
  headingDescription: 'eTravo provides dependable and professional corporate cab services in Panvel, catering to the business and industrial transport needs of this rapidly developing city. Whether you need daily staff commute solutions, executive cabs for meetings, or airport transfers for visiting clients, our services are designed to be punctual, comfortable, and customizable. With GPS-enabled vehicles, courteous chauffeurs, and flexible booking models, eTravo supports companies of all sizes in managing seamless transport within Panvel, to Navi Mumbai, Mumbai, and industrial zones around Raigad and Taloja.',

  top: 'Top Corporate Zones and Business Landmarks in Panvel Served by eTravo',
  topPlaces: [
    {
      title: 'Panvel Industrial Estate',
      description: 'This hub is home to several small and mid-size manufacturing units, logistics operations, and warehousing companies. eTravo provides scheduled cab services here for employee shifts, managerial visits, and admin staff, ensuring hassle-free commutes.'
    },
    {
      title: 'Kalamboli MIDC Zone',
      description: 'Just outside Panvel, this industrial belt requires structured transportation solutions. Our corporate cab plans here include multi-stop routes, early morning pickups, and executive travel to client and vendor meetings.'
    },
    {
      title: 'Orion Mall Panvel Business Wing',
      description: 'A new-age commercial and office space attracting startups, consultants, and service providers. eTravo offers daily executive cab rentals here for client movement, investor pickups, and internal team shuttles.'
    },
    {
      title: 'Khandeshwar & New Panvel West',
      description: 'These fast-developing sectors contain commercial buildings and co-working spaces. Our AC cab services cater to professionals working across Panvel with smooth intra-city connectivity and on-call bookings.'
    },
    {
      title: 'Taloja MIDC',
      description: 'A major industrial cluster often needing large-scale staff transport. eTravo runs fixed-route cabs and shift-based cab arrangements for corporates with contractual or full-time workforce movement.'
    },
    {
      title: 'Panvel Railway Station Area',
      description: 'A key junction for local and intercity travelers, this area benefits from our station-to-office and office-to-station cab integration, helping reduce employee travel fatigue and late arrivals.'
    },
    {
      title: 'CIDCO Smart City Nodes (Palaspe–Karanjade)',
      description: 'With the rise of smart infrastructure and new corporate establishments, eTravo supports businesses in these developing zones by offering scalable staff cab services with real-time fleet tracking.'
    },
    {
      title: 'Karnala SEZ & Logistics Corridor',
      description: 'This upcoming logistics hub requires round-the-clock mobility solutions for employees and supervisors. eTravo’s cabs here are equipped for long-distance staff pickup, flexible route planning, and day/night service availability.'
    },
    {
      title: 'Panvel Court & Government Complex',
      description: 'Legal firms, corporate consultants, and audit teams operating near the government complex often need executive-level cabs. We provide hourly rental and point-to-point drop services for professionals in these zones.'
    },
    {
      title: 'Upcoming Navi Mumbai International Airport Access Area',
      description: 'Panvel being the gateway to NMIA, companies booking client or staff travel to this region prefer our GPS-tracked, well-maintained corporate cabs for on-time arrival and drop-off services.'
    }
  ],

  services: [
    {
      name: 'Panvel Corporate Cab Rentals',
      description: 'Customized cab rental solutions for Panvel-based offices, manufacturing units, and startups. We offer fixed-term and flexible cab rental plans for employee travel, corporate events, and management mobility.'
    },
    {
      name: 'Business Cab Services Panvel',
      description: 'Daily and on-call cab services designed for business owners, field agents, and visiting clients. Choose from sedan, SUV, or executive-class vehicles, all available with trained chauffeurs and route tracking.'
    },
    {
      name: 'Employee Transport Cab Panvel',
      description: 'Fixed-route cab transport with optimized pickup and drop schedules, GPS tracking, and dedicated driver support. Ideal for shift operations and daily staff travel from nearby residential zones.'
    },
    {
      name: 'Corporate Staff Cabs Panvel',
      description: 'End-to-end cab coordination for daily staff commutes, team transfers, and multi-stop business routing across industrial and commercial zones in Panvel and beyond.'
    },
    {
      name: 'Reliable Corporate Cab Service Panvel',
      description: 'We are trusted by Panvel-based companies for our timely cab arrivals, clean vehicles, driver verification, and seamless trip planning for both daily and project-based transport.'
    },
    {
      name: 'AC Corporate Cabs Panvel',
      description: 'All our cabs are fully air-conditioned, sanitized, and equipped with comfortable seating — ensuring that your team arrives at work cool, calm, and refreshed.'
    },
    {
      name: 'Panvel Office Commute Cabs',
      description: 'Our office commute cabs are suited for multiple pickup points across New Panvel, Old Panvel, Kharghar, and Taloja, with scheduled arrival management and attendance logs.'
    },
    {
      name: 'Corporate Event Cab Rentals Panvel',
      description: 'Hosting a corporate meet or offsite in Panvel? We provide bulk cab bookings, guest logistics support, and full-day availability with coordination assistance for seamless event mobility.'
    },
    {
      name: 'Affordable Corporate Cabs Panvel',
      description: 'With flexible billing,  options, and monthly contracts, our cab services remain cost-effective for companies of all sizes operating from Panvel’s key zones.'
    },
    {
      name: 'Executive Cab Service Panvel',
      description: 'Our luxury cab services cater to company heads, international clients, and government liaisons, featuring top-end vehicles, professionally dressed chauffeurs, and absolute punctuality.'
    },
    {
      name: 'Panvel Business Travel Cabs',
      description: 'Whether traveling within Panvel, Navi Mumbai, or Mumbai for meetings, factory visits, or site checks, our business cab solutions ensure safe, scheduled, and professional transport.'
    },
    {
      name: 'Staff Pickup and Drop Cab Panvel',
      description: 'Round-the-clock pickup and drop for employees across shifts and departments. Our cabs are scheduled according to your operational calendar to maximize employee productivity.'
    },
    {
      name: 'Corporate Client Transport Panvel',
      description: 'Impress your visiting clients with clean, quiet, and chauffeur-driven cabs. From airport pickups to hotel-to-office drops, we manage complete client transportation logistics.'
    },
    {
      name: 'Panvel Airport Corporate Cabs',
      description: 'Our cabs offer 24/7 airport connectivity from Panvel to Mumbai Airport and NMIA (upcoming), complete with flight tracking, delay buffers, and arrival signage for guest pickup.'
    },
    {
      name: 'Business Meeting Cabs Panvel',
      description: 'Attending or hosting multiple business meetings across Panvel, Navi Mumbai, or Raigad? Our standby cabs are available by the hour or day, ensuring your schedule runs smoothly.'
    }
  ],

  tableData: [
    ['Panvel Corporate Cab Rentals', 'Business Cab Services Panvel'],
    ['Employee Transport Cab Panvel', 'Corporate Staff Cabs Panvel'],
    ['Reliable Corporate Cab Service Panvel', 'AC Corporate Cabs Panvel'],
    ['Panvel Office Commute Cabs', 'Corporate Event Cab Rentals Panvel'],
    ['Affordable Corporate Cabs Panvel', 'Executive Cab Service Panvel'],
    ['Panvel Business Travel Cabs', 'Staff Pickup and Drop Cab Panvel'],
    ['Corporate Client Transport Panvel', 'Panvel Airport Corporate Cabs'],
    ['Business Meeting Cabs Panvel', '']
  ],



"whychoose": [
    {
        "WhyChooseheading": "Dependable Corporate Cab Service in Panvel",
        "WhyChoosedescription": "eTravo offers structured and professional cab services for corporate clients in Panvel, serving industrial zones, business parks, and IT hubs with safe, punctual, and cost-effective travel options."
    },
    {
        "WhyChooseheading": "Fleet Options for All Corporate Needs",
        "WhyChoosedescription": "Our fleet includes hatchbacks, sedans, SUVs, and MPVs suited for daily employee transport, executive travel, airport pickups, and intercity business meetings."
    },
    {
        "WhyChooseheading": "Fixed Cab Assignments with Trained Chauffeurs",
        "WhyChoosedescription": "We assign fixed vehicles and background-verified chauffeurs for corporate clients to ensure consistency, punctuality, and familiarity with company routes and expectations."
    },
    {
        "WhyChooseheading": "Shift-Based Transport for Industrial Clients",
        "WhyChoosedescription": "Panvel's growing industrial landscape demands shift-based transport. We offer tailored solutions for 24/7 operations, ensuring timely pickup and drop-off for every employee shift."
    },
    {
        "WhyChooseheading": "Real-Time GPS Tracking and Monitoring",
        "WhyChoosedescription": "All vehicles are GPS-enabled, allowing live tracking of rides, ETA alerts, and route monitoring—perfect for HR, admin, and transport managers."
    },
    {
        "WhyChooseheading": "Corporate Packages with Fuel and Non-Fuel Plans",
        "WhyChoosedescription": "Choose from fuel-inclusive or fuel-exclusive plans as per your organization’s budgeting model. Transparent billing ensures no surprise charges."
    },
    {
        "WhyChooseheading": "Clean, Sanitized Vehicles and Safety Compliance",
        "WhyChoosedescription": "All our cabs are regularly sanitized and maintained. Safety features include seat belts, fire extinguishers, and first-aid kits for a secure travel experience."
    },
    {
        "WhyChooseheading": "Monthly GST Billing and Trip Reports",
        "WhyChoosedescription": "We provide GST-compliant monthly invoices along with usage logs and trip summaries—ideal for financial audits, internal approvals, and record keeping."
    }
]
}


const faqData = [
    [
        {
            question: 'Which areas in and around Panvel are covered?',
            answer: 'We serve all major locations including Old Panvel, New Panvel, MIDC Taloja, Kalamboli, Kharghar, and nearby industrial and commercial zones.'
        },
        {
            question: 'Do you offer shift-based cab services for factories?',
            answer: 'Yes, we specialize in shift-based transport, with vehicles aligned to morning, afternoon, and night shift timings for industrial and manufacturing clients.'
        },
        {
            question: 'Can we book dedicated cabs for senior management?',
            answer: 'Absolutely. We offer executive sedans and SUVs with trained chauffeurs for management and VIP travel needs in and around Panvel.'
        },
        {
            question: 'Do you provide GPS tracking for all vehicles?',
            answer: 'Yes, all our cabs are GPS-enabled and integrated with a real-time tracking system to ensure visibility and route safety.'
        },
        {
            question: 'Can we opt for fuel-free billing packages?',
            answer: 'Yes, fuel-inclusive and exclusive plans are both available to match your organization’s accounting and control preferences.'
        },
        {
            question: 'Will we receive monthly GST-compliant invoices?',
            answer: 'Yes, eTravo offers detailed monthly invoices with GST and itemized trip logs for seamless financial reporting and compliance.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Prakash Patil',
        designation: 'Transport Head, Panvel Forge & Gears',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has simplified our staff transport system with their corporate cabs in Panvel. Timely, safe, and fully managed—excellent support for our shift operations.”'
    },
    {
        name: 'Ms. Anuja Jagtap',
        designation: 'Admin Executive, Vertex Pharmaceuticals',
        rating: [1, 1, 1, 1, 1],
        text: '“From executive pickups to factory shuttle services, eTravo handles it all with great professionalism. Their monthly reporting and billing process is super smooth.”'
    }
];




















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Panvel",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-service-panvel.jpg",
  "description": "Book corporate cab services in Panvel with eTravo. Ideal for staff transport, office commute, business meetings, and airport transfers. Reliable, affordable, and AC corporate cabs with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7894"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-panvel"
  }
};







    return (
        <div>
<Helmet>
  <title>Corporate Cab Service in Panvel | Staff Transport & Business Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Hire reliable corporate cab services in Panvel for office commutes, business meetings, airport transfers, and staff transport. Affordable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinpanvel;